










import Vue from 'vue';
import CustomAuthenticator from './auth-custom-authenticator.vue';

export default Vue.extend({

  name: 'AuthAuthenticator',
  components: {
    'auth-custom-authenticator': CustomAuthenticator
  },
  props: {},

  data() {
    return {
      authConfig: {
        usernameAttributes: 'email',
        signInConfig: {
          header: 'Login To Your Account'
        },
        confirmSignUpConfig: {
          header: 'Please enter the Confirmation Code that was emailed to you:'
        },
        signUpConfig: {
          header: 'Create an Account',
          hideAllDefaults: true,
          defaultCountryCode: '1',
          signUpFields: [
            {
              label: 'Email',
              key: 'email',
              required: true,
              displayOrder: 1,
              type: 'string',
              signUpWith: true
            },
            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 4,
              type: 'password'
            },
          ]
        }
      }, // authConfig END
    }
  },

  mounted() {
  },

  computed: {},

  methods: {},

});
